import { State } from "../../../components/organisms/Cards/user-card-controller/types";


export interface IUser {
    id: string,
    firstName:string,
    lastName:string,
    name: string,
    userName:string,
    email: string,
    status:string,
    state: State,
    image:string,
    designation:string,
    jobTitle:string,
    password:string,
    groupType:string,
    companyName:string,
    mobileNumber:string,
    profileImage:string,
    createdBy: string,
    createdDate: string,
    modifiedBy:string,
    modifiedDate: string,
    userRole:string,
    passwordHash:string,
    userId: number | string,
    profilePicture:any,
    organizationId?: number | null,
}

export enum UserStatus {
  Active = "Active",
  Inactive = "Inactive",
  Pending = "Pending",
  Suspended = "Suspended",
}

export enum UserRole {
  GlobalAdmin = "GlobalAdmin",
  Admin = "Admin",
  User = "User",
  Manager = "Manager",
}

